var React = require('react');
var Link = require('react-router').Link;
var METRO_HUBS = require('./metro-hubs');
var STAKE = require('./stake-placement');

var HUB_LINKS = [
  { to: '/texas-poker-rooms', label: 'Texas poker rooms' },
  { to: '/california-poker-rooms', label: 'California poker rooms' },
  { to: '/florida-poker-rooms', label: 'Florida poker rooms' },
  { to: '/washington-poker-rooms', label: 'Washington poker rooms' }
];

var CITY_LINKS = Object.keys(METRO_HUBS).map(function(slug) {
  return { to: '/' + slug, label: METRO_HUBS[slug].footerLabel };
});

var GUIDE_LINKS = [
  { to: '/all-poker-rooms', label: 'All poker rooms by state' },
  { to: '/guides/how-daily-tournaments-work', label: 'How daily tournaments work' },
  { to: '/guides/tournament-terms', label: 'Tournament terms' },
  { to: '/guides/poker-tournament-faq', label: 'Poker tournament FAQ' },
  { to: STAKE.guide, label: STAKE.footer.guideLabel },
  { to: '/about', label: 'About & corrections' }
];

var SiteFooter = React.createClass({
  render: function () {
    return (
      <footer className="site-footer" role="contentinfo">
        <div className="site-footer-inner">
          <p className="site-footer-label">Browse by state</p>
          <ul className="site-footer-links">
            {HUB_LINKS.map(function (item) {
              return (
                <li key={item.to}>
                  <Link to={item.to}>{item.label}</Link>
                </li>
              );
            })}
          </ul>
          <p className="site-footer-label">Browse by city</p>
          <ul className="site-footer-links">
            {CITY_LINKS.map(function (item) {
              return (
                <li key={item.to}>
                  <Link to={item.to}>{item.label}</Link>
                </li>
              );
            })}
          </ul>
          <p className="site-footer-label">Guides</p>
          <ul className="site-footer-links">
            {GUIDE_LINKS.map(function (item) {
              return (
                <li key={item.to}>
                  <Link to={item.to}>{item.label}</Link>
                </li>
              );
            })}
            <li><a href={STAKE.go('footer')} rel="sponsored nofollow">{STAKE.footer.joinLabel}</a></li>
          </ul>
        </div>
      </footer>
    );
  }
});

module.exports = SiteFooter;



// WEBPACK FOOTER //
// ./js/site-footer.jsx